export default function ImpactMetrics() {
  const metrics = [
    {
      value: "45%",
      label: "Query Performance Improvement",
    },
    {
      value: "300+",
      label: "Active System Users",
    },
    {
      value: "99.9%",
      label: "API Reliability Target",
    },
    {
      value: "10+",
      label: "Production-Ready Projects Built",
    },
  ];

  return (
    <section className="relative py-32 bg-slate-50 overflow-hidden">

      {/* Subtle Section Glow */}
      <div className="absolute -top-40 right-1/2 translate-x-1/2 w-[600px] h-[400px] bg-blue-100/40 blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">

        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-sm uppercase tracking-widest text-blue-600 font-semibold mb-4">
            Impact
          </p>

          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
            Measurable Results
          </h2>

          <p className="text-lg text-slate-600 mt-4 max-w-2xl mx-auto leading-relaxed">
            Engineering systems that deliver performance, reliability,
            and real-world scalability.
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">

          {metrics.map((metric) => (
            <div
              key={metric.label}
              className="
                bg-white
                border border-slate-200
                rounded-2xl
                p-8
                text-center
                transition duration-300
                hover:-translate-y-2
                hover:shadow-xl
                hover:shadow-blue-500/10
              "
            >
              <div className="text-4xl md:text-5xl font-semibold text-slate-900 mb-4 tracking-tight">
                {metric.value}
              </div>

              <div className="text-slate-600 text-xs md:text-sm tracking-widest uppercase">
                {metric.label}
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}